/*
 * Sneakies — header additions (loaded globally from layout/theme.liquid,
 * right after sn-header.css).
 *
 * One job: put an "Account" row into the mobile nav drawer. The mobile design
 * shows hamburger / wordmark / Cart in the bar and lists Shop, FAQ and
 * Account in the right-hand drawer — but this build's stock drawer renders
 * only the menu linklist and has no account slot (.menu-drawer__account is
 * dead CSS here). Rather than editing the 1200-line stock header-drawer
 * snippet on a live-synced theme, the row is appended by script, wearing the
 * drawer's own row classes so sn-header.css styles it like the others.
 *
 * The header's own Account control is hidden below 700px by sn-header.css; at
 * desktop widths this row is simply never seen (the drawer itself is
 * hamburger-only below 750px). Signed out, the row goes straight to Shopify's
 * hosted sign-in via /customer_authentication/login; signed in it goes to
 * /pages/account, the themed account area built in Phase 8. Both match the
 * header's own control — one click, one destination, no menu in between.
 */
(function () {
  if (window.__snHeaderInit) return;
  window.__snHeaderInit = true;

  function inject() {
    var nav = document.querySelector('.menu-drawer nav ul.menu-drawer__menu');
    if (!nav || nav.querySelector('[data-sn-drawer-account]')) return;
    var li = document.createElement('li');
    li.className = 'menu-drawer__list-item';
    var a = document.createElement('a');
    /* Signed out -> Shopify's hosted sign-in (it owns the code step, which
       cannot live on this domain); signed in -> the themed account area
       (/pages/account, Phase 8). window.__snSignedIn is set inline in
       layout/theme.liquid, right above this script's tag. */
    a.href = window.__snSignedIn
      ? '/pages/account'
      : '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname);
    /* On the account pages, mark the row current so it gets the drawer's ink
       left-border, same as the theme's own rows (sn-header.css styles
       [aria-current='page'] on --mainlist items). */
    if (location.pathname === '/pages/login' || location.pathname === '/pages/account') a.setAttribute('aria-current', 'page');
    a.setAttribute('data-sn-drawer-account', '');
    a.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist focus-inset';
    var span = document.createElement('span');
    span.className = 'menu-drawer__menu-item-text wrap-text';
    span.textContent = 'Account';
    a.appendChild(span);
    nav.appendChild(li);
    li.appendChild(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  /*
   * The theme's header components re-render the drawer after this script's
   * first pass (verified live: the row was injected, then gone by the time
   * the drawer opened), so a one-shot injection is not enough. Watch the
   * header group and re-inject whenever the row is missing — the guard in
   * inject() makes repeat calls free.
   */
  if (typeof MutationObserver === 'function') {
    var scope = document.getElementById('header-group') || document.body;
    if (scope) {
      new MutationObserver(function () { inject(); }).observe(scope, { childList: true, subtree: true });
    }
  }
})();
